// 숫자형 콤마넣기
export function makeIntComma(intVal: number): string {
    intVal *= 1; // 숫자형 변경
    const option = {
        maximumFractionDigits: 4, // 최대 소수점 자리
    };
    const result = intVal.toLocaleString("ko-KR", option);
    return result;
}

export function isNewPost(dateString: string): boolean {
    const now = new Date();
    const createdAt = new Date(dateString + "T00:00:00");
    const diffInMs = now.getTime() - createdAt.getTime();
    const diffInHours = diffInMs / (1000 * 60 * 60); // 밀리초 → 시간

    return diffInHours < 24;
}
export const ilshinGroupPhone = (type: string) => {
    const ilshinGroupPhonsMap = {
        morning: "1566-0685",
        air: "1588-0605",
        express: "1661-1116",
        quick: "1661-1116",
    };

    let number;

    switch (type) {
        case "morning":
            number = ilshinGroupPhonsMap["morning"];
            break;
        case "air":
            number = ilshinGroupPhonsMap["air"];
            break;
        case "express":
            number = ilshinGroupPhonsMap["express"];
            break;
        case "quick":
            number = ilshinGroupPhonsMap["quick"];
            break;
    }
    return number;
};

export type RouteTypes = "air" | "express" | "quick" | "morning";

// Date -> 2025-03-07
export const formatDateToString = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 월은 0부터 시작하므로 +1
    const day = String(date.getDate()).padStart(2, "0");

    // yyyy-MM-dd 형식으로 변환
    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate;
};

export const allowedMimeTypes = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/gif",
    "application/pdf",
    "application/msword", // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
    "application/vnd.ms-powerpoint", // .ppt
    "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
    "application/vnd.ms-excel", // .xls
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
    "application/x-hwp", // HWP files
    "application/zip", // ZIP files
    "text/plain",
    "video/mpg", // MPG
    "video/mpeg", // MPEG
    "video/avi", // AVI
    "video/x-ms-wmv", // WMV
    "video/x-ms-asf", // ASF
    "video/x-ms-asx", // ASX
    "video/mp4", // MP4
];

export const toastErrorSyle = {
    style: {
        width: "100%",
        maxWidth: "560px",
        backgroundColor: "#FF4242",
        padding: "16px",
        fontSize: "18px",
        color: "#ffffff",
    },
};

export const isEditorEmpty = (html: string) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.innerText.trim() === "";
};

const companyMenu = {
    menu: "회사소개",
    // path:"",
    category: "company",
    subMenu: [
        {
            menu: "회사소개 / CEO인사말",
            path: "/company/ceo-message",
        },
        {
            menu: "연혁",
            path: "/company/history",
        },
        {
            menu: "조직도",
            path: "/company/organization",
        },
        {
            menu: "CI소개",
            path: "/company/ci",
        },
        {
            menu: "BRANCH",
            path: "/company/branch",
        },
        {
            menu: "오시는길",
            path: "/company/location",
        },
    ],
};
const membershipMenu = {
    menu: "멤버쉽",
    // path:"",
    category: "membership",
    subMenu: [
        {
            menu: "로그인",
            path: "/login",
        },
        {
            menu: "회원가입",
            path: "/signup",
        },
    ],
};
export const siteMap = [
    {
        type: "air",
        depth1: [
            { ...companyMenu },
            {
                menu: "운송 서비스",
                // path:"",
                category: "transport",
                subMenu: [
                    {
                        menu: "국제특송 서비스",
                        path: "/transport/express",
                    },
                    {
                        menu: "항공카고&해운서비스",
                        path: "/transport/air-sea",
                    },
                    {
                        menu: "전시화물 서비스",
                        path: "/transport/exhibition",
                    },
                    {
                        menu: "주요 CLIENT 현황",
                        path: "/transport/clients",
                    },
                    {
                        menu: "전시회 운송 현황",
                        path: "/transport/exhibitions",
                    },
                ],
            },
            {
                menu: "고객 서비스",
                // path:"",
                category: "customer",
                subMenu: [
                    {
                        menu: "거래내역조회",
                        path: "/customer/transactions",
                    },
                    {
                        menu: "화물추적조회",
                        path: "/customer/tracking",
                    },
                    {
                        menu: "청구서조회",
                        path: "/customer/invoices",
                    },
                    {
                        menu: "화물픽업예약",
                        path: "/customer/pickup",
                    },
                    {
                        menu: "운송견적문의",
                        path: "/customer/estimate",
                    },
                ],
            },
            {
                menu: "고객센터",
                // path:"",
                category: "support",
                subMenu: [
                    {
                        menu: "공지사항",
                        path: "/support/notices",
                    },
                    {
                        menu: "BL작성법",
                        path: "/support/bl-guide",
                    },
                    {
                        menu: "운송장 및 부자재 요청",
                        path: "/support/supplies",
                    },
                    {
                        menu: "일신그룹 고객센터",
                        path: "/support/tels",
                    },
                ],
            },
            { ...membershipMenu },
        ],
    },
    {
        type: "morning",
        depth1: [
            { ...companyMenu },
            {
                menu: "운송 서비스",
                // path:"",
                category: "transport",
                subMenu: [
                    {
                        menu: "모닝서비스",
                        path: "/transport/express",
                    },
                    {
                        menu: "전국센터조직도",
                        path: "/transport/center-network",
                    },
                    {
                        menu: "주요 CLIENT 현황",
                        path: "/transport/clients",
                    },
                ],
            },
            {
                menu: "고객 서비스",
                // path:"",
                category: "customer",
                subMenu: [
                    {
                        menu: "인터넷오더접수",
                        path: "/customer/online-order",
                    },
                    {
                        menu: "운송장조회",
                        path: "/customer/tracking",
                    },
                    {
                        menu: "청구서조회",
                        path: "/customer/invoices",
                    },
                    {
                        menu: "청구서수정요청",
                        path: "/customer/invoices-edit",
                    },
                    {
                        menu: "운송장 신청접수",
                        path: "/customer/tracking-request",
                    },
                ],
            },
            {
                menu: "고객센터",
                // path:"",
                category: "support",
                subMenu: [
                    {
                        menu: "사용문의",
                        path: "/support/courier-inquiry",
                    },
                    {
                        menu: "공지사항",
                        path: "/support/notices",
                    },
                    {
                        menu: "FAQ",
                        path: "/support/faq",
                    },
                    // {
                    //     menu: "일신그룹 고객센터",
                    //     path: "/support/tels",
                    // },
                ],
            },
            {
                menu: "채용지원",
                // path:"",
                category: "",
                subMenu: [
                    {
                        menu: "채용지원",
                        path: "/recruit",
                    },
                ],
            },
            { ...membershipMenu },
        ],
    },
    {
        type: "quick",
        depth1: [
            { ...companyMenu },
            {
                menu: "운송 서비스",
                // path:"",
                category: "transport",
                subMenu: [
                    {
                        menu: "요금표",
                        path: "/transport/price",
                    },
                    {
                        menu: "오토바이퀵",
                        path: "/transport/motocycle",
                    },
                    {
                        menu: "다마스·라보",
                        path: "/transport/damas-labo",
                    },
                    {
                        menu: "화물차량",
                        path: "/transport/truck",
                    },
                    {
                        menu: "화물차량 적재함 규격표",
                        path: "/transport/truck-size",
                    },
                    {
                        menu: "고속버스&KTX연계",
                        path: "/transport/bus-ktx",
                    },
                ],
            },
            {
                menu: "고객 서비스",
                // path:"",
                category: "customer",
                subMenu: [
                    {
                        menu: "퀵&화물 인터넷접수",
                        path: "/customer/quick-order",
                    },
                    {
                        menu: "배송조회",
                        path: "/customer/delivery",
                    },
                    {
                        menu: "오더조회",
                        path: "/customer/order",
                    },
                    {
                        menu: "정산조회",
                        path: "/customer/settlement",
                    },
                ],
            },
            {
                menu: "고객센터",
                // path:"",
                category: "support",
                subMenu: [
                    {
                        menu: "공지사항",
                        path: "/support/notices",
                    },
                    {
                        menu: "FAQ",
                        path: "/support/faq",
                    },
                    {
                        menu: "일신그룹 고객센터",
                        path: "/support/tels",
                    },
                ],
            },
            { ...membershipMenu },
        ],
    },
    {
        type: "express",
        depth1: [
            { ...companyMenu },
            {
                menu: "운송 서비스",
                // path:"",
                category: "transport",
                subMenu: [
                    {
                        menu: "화물차량",
                        path: "/transport/service",
                    },
                ],
            },
            {
                menu: "고객 서비스",
                // path:"",
                category: "customer",
                subMenu: [
                    {
                        menu: "특송화물 인터넷접수",
                        path: "/customer/express-order",
                    },
                    {
                        menu: "배송조회",
                        path: "/customer/delivery",
                    },
                    {
                        menu: "오더조회",
                        path: "/customer/order",
                    },
                    {
                        menu: "정산조회",
                        path: "/customer/settlement",
                    },
                ],
            },
            {
                menu: "고객센터",
                // path:"",
                category: "support",
                subMenu: [
                    {
                        menu: "공지사항",
                        path: "/support/notices",
                    },
                    {
                        menu: "FAQ",
                        path: "/support/faq",
                    },
                    {
                        menu: "일신그룹 고객센터",
                        path: "/support/tels",
                    },
                ],
            },
            { ...membershipMenu },
        ],
    },
];

export const shortcut = (type?: string, idx?: string) => {
    let domain = "ilshingroup.com";
    // if (process.env.NODE_ENV === "development") {
    //     domain = "localhost:3000";
    // }
    return {
        화물픽업예약: `https://air.${domain}/customer/pickup`,
        운송견적문의: `https://air.${domain}customer/estimate`,
        운송장및부자재요청: `https://air.${domain}/support/supplies`,
        공지사항: `https://${type}.${domain}/support/notices`,
        공지사항상세: `https://${type}.${domain}/support/notices/${idx}`,
        특송화물인터넷접수: `https://express.${domain}/customer/express-order`,
        퀵화물인터넷접수: `https://quick.${domain}/customer/quick-order`,
        faq: `https://${type}.${domain}/support/faq`,
        운송장신청접수: `https://morning.${domain}/customer/tracking-request`,
        청구서수정및문의: `https://morning.${domain}/customer/invoices-edit`,
        청구서수정및문의상세: `https://morning.${domain}/customer/invoices-edit/${idx}`,
    };
};

export const formatTelNumber = (value: string, prevValue: string, cursorPosition?: number) => {
    const onlyNumbers = value.replace(/\D/g, ""); // 숫자만 유지
    let formatted = "";

    // 3자리 지역번호 목록
    const threeDigitAreaCodes = ["031", "032", "033", "041", "042", "043", "051", "052", "053", "054", "055", "061", "062", "063", "064"];

    const isSeoul = onlyNumbers.startsWith("02");
    const isThreeDigitAreaCode = threeDigitAreaCodes.some(code => onlyNumbers.startsWith(code));
    const isMobileOrOther = !isSeoul && !isThreeDigitAreaCode;
    const maxLength = isSeoul ? 10 : 11; // 서울(02)는 10자리, 나머지는 11자리

    if (onlyNumbers.length > maxLength) return { formatted: prevValue, cursorOffset: 0 };

    if (isSeoul) {
        if (onlyNumbers.length <= 2) {
            formatted = onlyNumbers;
        } else if (onlyNumbers.length <= 5) {
            formatted = `${onlyNumbers.slice(0, 2)}-${onlyNumbers.slice(2)}`;
        } else if (onlyNumbers.length <= 9) {
            formatted = `${onlyNumbers.slice(0, 2)}-${onlyNumbers.slice(2, 5)}-${onlyNumbers.slice(5)}`;
        } else {
            formatted = `${onlyNumbers.slice(0, 2)}-${onlyNumbers.slice(2, 6)}-${onlyNumbers.slice(6)}`;
        }
    } else if (isThreeDigitAreaCode || isMobileOrOther) {
        if (onlyNumbers.length <= 3) {
            formatted = onlyNumbers;
        } else if (onlyNumbers.length <= 6) {
            formatted = `${onlyNumbers.slice(0, 3)}-${onlyNumbers.slice(3)}`;
        } else if (onlyNumbers.length <= 10) {
            formatted = `${onlyNumbers.slice(0, 3)}-${onlyNumbers.slice(3, 6)}-${onlyNumbers.slice(6)}`;
        } else {
            formatted = `${onlyNumbers.slice(0, 3)}-${onlyNumbers.slice(3, 7)}-${onlyNumbers.slice(7)}`;
        }
    }

    // 커서 위치 보정
    const dashCountBefore = (prevValue.slice(0, cursorPosition).match(/-/g) || []).length;
    const dashCountAfter = (formatted.slice(0, cursorPosition).match(/-/g) || []).length;
    const cursorOffset = dashCountAfter - dashCountBefore;

    return { formatted, cursorOffset };
};
